import React from 'react';
import Button from '@raydiant/raydial/components/Button';
import Text from '@raydiant/raydial/components/Text';
import { tv } from 'tailwind-variants';

const styles = tv({
  base: 'flex items-center gap-4 rounded-xl p-4 w-full text-start',
  variants: {
    selected: {
      true: 'bg-gray-100',
    },
    outline: {
      true: 'border-gray-200 border',
    },
    clickable: {
      true: 'hover:bg-gray-100',
    },
  },
  slots: {
    img: 'size-16 rounded-lg flex items-center justify-center bg-gray-200',
    subtitle: 'text-lg text-gray-400 capitalize',
  },
});

interface ProductHubCardProps {
  imgSrc?: string;
  icon?: React.ReactNode;
  title: string;
  description: React.ReactNode;
  selected?: boolean;
  onPress?: () => void;
  rightAction?: React.ReactNode;
  outline?: boolean;
}

const ProductHubCard: React.FC<ProductHubCardProps> = ({
  imgSrc,
  title,
  description,
  selected,
  onPress,
  icon,
  rightAction,
  outline,
}) => {
  const s = styles();
  const showOutline = !!onPress || outline;
  const commonProps = {
    className: s.base({
      selected,
      outline: showOutline,
      clickable: !!onPress,
    }),
  };

  const Content = (
    <>
      <div className={s.img()}>
        {imgSrc && <img src={imgSrc} alt="connector" />}
        {icon}
      </div>
      <div className="mr-auto">
        <Text as="h3" variant="smallSubheader">
          {title}
        </Text>
        <Text className={s.subtitle()}>{description}</Text>
      </div>
      {rightAction && <div>{rightAction}</div>}
    </>
  );

  return onPress ? (
    <Button variant="unstyled" {...commonProps} onPress={onPress}>
      {Content}
    </Button>
  ) : (
    <div {...commonProps}>{Content}</div>
  );
};

export default ProductHubCard;
